import React from 'react';

import { AuthProvider } from './auth';
import { ToastProvider } from './toast';
import { MessageProvider } from './message';
import { UserStatusProvider } from './userStatus';
import { UserConfigProvider } from './userConfig';

const AppProvider: React.FC = ({ children }) => (
  <AuthProvider>
    <UserConfigProvider>
      <MessageProvider>
        <ToastProvider>
          <UserStatusProvider>{children}</UserStatusProvider>
        </ToastProvider>
      </MessageProvider>
    </UserConfigProvider>
  </AuthProvider>
);

export default AppProvider;
